import GdPermissionDialog, {
  GD_PERMISSION_TYPE,
} from "@/components/GdPermissionDialog";
import VerifyConfirm from "@/components/Verify/Confirm";
import useAppStore from "@/context/store";
import { safeParse } from "@/utils/safeParse";
import axios from "axios";
import { isEmpty } from "lodash";
import { compile } from "path-to-regexp";
import HBMessage from "../components/HBMessage";
import { destroyAll } from "../components/HBModal/ModalWrap";
import LoginDialog from "../components/LoginModal";
import { getCaptchaError } from "./error";
import { REQUEST_MESSAGE_KEY } from "./request";
import { getTransferHeaders } from "./server/headerTransfer";

export const ERR_CODE = {
  verify: 555,
  notLogin: 401,
};

// 请求拦截器
function requestSuccessFn(config) {
  config.withCredentials = true;
  const {
    url,
    options: { params },
    noParse,
  } = config;

  let target = url;

  if (!noParse && target.indexOf(":") > -1) {
    if (!params || isEmpty(params)) {
      throw new Error(`request ${target}` + "Not found Params!");
    }
    target = compile(url)(params);
    config.url = target;
  }

  if (typeof window === "undefined") {
    const serverTransferHeader = getTransferHeaders();
    config.headers = { ...serverTransferHeader, ...(config.headers || null) };
  }

  return config;
}

// 请求统一错误处理
function requestFailFn(error) {
  console.error("[request error]");
  throw error;
}

// 响应拦截器
function responseSuccessFn(res) {
  const {
    url,
    options: { ignoreMessage, ignoreGdPermission, ignoreVerify, returnRes },
  } = res.config;
  const { captchaKey, msg, err } = res.data;

  if (captchaKey && err === 500) {
    !ignoreVerify &&
      VerifyConfirm({
        captchakey: captchaKey,
        title: getCaptchaError(msg),
      });
    return {
      err: ERR_CODE.verify,
      captchakey: captchaKey,
      msg: getCaptchaError(msg),
    };
  }

  // 稿定租户权限问题处理
  if (res.data.err === 403 && !ignoreGdPermission) {
    switch (res.data.msg) {
      case "权限校验失败":
        GdPermissionDialog.open({
          type: GD_PERMISSION_TYPE.noauth,
          operation: "当前操作",
        });
        break;

      case "已被踢出组织":
        GdPermissionDialog.open({
          type: GD_PERMISSION_TYPE.remove,
          operation: "当前操作",
        });
        break;
      case "角色权限不足":
        GdPermissionDialog.open({
          type: GD_PERMISSION_TYPE.visitor,
          operation: "当前操作",
        });
        break;
      case "组织不存在或已解散":
        GdPermissionDialog.open({
          type: GD_PERMISSION_TYPE.noorg,
        });
        break;
      default:
        break;
    }
  }

  if (res.data.err && !ignoreMessage && typeof window !== "undefined") {
    HBMessage.error({
      content: res.data.msg || res.data.err,
      key: REQUEST_MESSAGE_KEY,
      duration: 3,
    });
  }

  let pagination;
  if (res.headers && res.headers["x-pagination"]) {
    pagination = safeParse(res.headers["x-pagination"]);
  }

  // 如果需要返回响应对象，则直接返回
  if (returnRes) {
    return res;
  }

  if (!process.browser) {
    return pagination ? { pagination, data: res.data } : res.data;
  }

  // let isRegister = true;
  // try {
  //   const response = JSON.parse(res.request.response) || null;
  //   if (typeof response?.isRegister !== "undefined") {
  //     isRegister = response.isRegister;
  //   }
  // } catch (err) {}

  // 其他设备登录提醒
  if (
    res.data.err === ERR_CODE.notLogin &&
    res.data.ext_message &&
    typeof window !== "undefined"
  ) {
    import("@/components/LoginModal/otherDeviceLogin").then(
      ({ OtherDeviceLoginInfo }) => {
        OtherDeviceLoginInfo.open(res.data.ext_message.detail);
      }
    );

    useAppStore.getState().setUser(null);

    return {
      err: ERR_CODE.notLogin,
      msg: "登录失效，请重新登录!",
    };
  }

  // 登录失效白名单
  const whiteList = ["/auth/", "/message/unreads"];
  // 登录失效逻辑处理
  if (!whiteList.includes(url) && res.data.err === 401) {
    const errMsg = "登录失效，请重新登录!";
    if (!ignoreMessage && typeof window !== "undefined") {
      HBMessage.error({
        content: errMsg,
        key: REQUEST_MESSAGE_KEY,
        duration: 3,
      });
    }
    // 关闭登录弹窗
    destroyAll();
    // 清除用户信息
    useAppStore.getState().setUser(null);
    // 登录失效，打开登录弹窗
    LoginDialog.open();

    return {
      err: ERR_CODE.notLogin,
      msg: errMsg,
    };
  }
  return pagination ? { pagination, data: res.data } : res.data;
}

// 响应统一错误处理
function responseFailFn(error) {
  const msg = error.message || "";

  if (msg.indexOf("timeout") >= 0) {
    error.message = "请求超时，请重试或检查网络状态";
  }

  if (msg.includes("Network Error")) {
    error.message = "网络错误，请重试或检查网络状态";
  }

  throw error;
}

function createRequest({ BaseURL }) {
  const instance = axios.create({
    baseURL: BaseURL,
  });

  // 请求拦截器
  instance.interceptors.request.use(requestSuccessFn, requestFailFn);

  // 响应拦截器
  instance.interceptors.response.use(responseSuccessFn, responseFailFn);

  return instance;
}

export default createRequest;
